<script setup>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text */
import { ref } from 'vue';
import GalleryView from 'dashboard/components/widgets/conversation/components/GalleryView.vue';
const props = defineProps({ attachments: { type: Array, default: () => [] } });
const selected = ref(null);
const failed = ref({});
const safeUrl = value =>
  typeof value === 'string' &&
  (/^https:\/\//.test(value) || /^\/(?!\/)/.test(value));
</script>

<template>
  <div class="flex flex-wrap gap-2">
    <template v-for="attachment in props.attachments" :key="attachment.id">
      <button
        v-if="
          ['image', 'video', 'audio'].includes(attachment.file_type) &&
          safeUrl(attachment.data_url)
        "
        type="button"
        class="rounded-lg border border-n-weak p-2 text-n-slate-12 focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-brand"
        aria-label="Открыть вложение"
        @click="selected = attachment"
      >
        <img
          v-if="attachment.file_type === 'image' && !failed[attachment.id]"
          :src="
            safeUrl(attachment.thumb_url)
              ? attachment.thumb_url
              : attachment.data_url
          "
          alt="Изображение объявления"
          class="size-24 object-cover rounded-md"
          loading="lazy"
          @error="failed[attachment.id] = true"
        />
        <span v-else>{{
          failed[attachment.id]
            ? 'Не удалось загрузить превью — открыть'
            : attachment.file_type === 'video'
              ? 'Посмотреть видео'
              : 'Прослушать аудио'
        }}</span>
      </button>
      <a
        v-else-if="safeUrl(attachment.data_url)"
        :href="attachment.data_url"
        target="_blank"
        rel="noopener noreferrer"
        class="text-n-blue-11 underline"
        >Открыть документ</a
      >
      <span v-else>
        <span class="text-sm text-n-slate-11"
          >Вложение недоступно. Проверьте сообщение в Telegram.</span
        >
      </span>
    </template>
  </div>
  <GalleryView
    v-if="selected"
    show
    :attachment="selected"
    :all-attachments="[
      selected,
      ...props.attachments.filter(
        item =>
          item.id !== selected.id &&
          ['image', 'video', 'audio'].includes(item.file_type) &&
          safeUrl(item.data_url)
      ),
    ]"
    @close="selected = null"
  />
</template>
